import { createSelector } from "reselect";

const tour = (state) => state.tour.tour;
export const getTour = createSelector([tour], (tour) => tour);

const stepIndex = (state) => state.tour.stepIndex;
export const getStepIndex = createSelector(
  [stepIndex],
  (stepIndex) => stepIndex
);

const tourData = (state) => state.tour.tourData;
export const getTourData = createSelector([tourData], (tourData) => tourData);
